import { pedidoService } from '@/services'

export default {
  namespaced: true,
  state: {
    pedidos: [],
    estado: '',
    tamanoPagina: 30
  },
  getters: {
    sucursal: (state, getters, rootState) => {
      return rootState.sesion.sucursal
    },
    bodega: (state, getters, rootState) => {
      return rootState.sesion.bodega
    },
    pedidos: (state) => state.pedidos,
    tamanoPagina: (state) => state.tamanoPagina,
    estaCargando: (state) => state.estado === 'loading'
  },
  mutations: {
    PEDIDOS_REQUEST: (state) => (state.estado = 'loading'),
    PEDIDOS_SUCCESS: (state, payload) => {
      state.pedidos = payload
      state.estado = 'ok'
    },
    PEDIDOS_ERROR: (state) => (state.estado = 'error')
  },
  actions: {
    updatePedidos({ commit, getters }) {
      if (getters.bodega) {
        commit('PEDIDOS_REQUEST')
        return pedidoService
          .getPedidosCliente(getters.bodega.id)
          .then((response) => commit('PEDIDOS_SUCCESS', response.data))
          .catch((_) => {
            commit('PEDIDOS_ERROR')
          })
      }
    }
  }
}
